import script from "./TaskDetailTab.vue?vue&type=script&setup=true&lang=js"
export * from "./TaskDetailTab.vue?vue&type=script&setup=true&lang=js"

import "./TaskDetailTab.vue?vue&type=style&index=0&id=1da05332&lang=css"

const __exports__ = script;

export default __exports__